import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { Brand } from "@/components/site/brand";
import { DisclaimerBar } from "@/components/site/disclaimer-bar";

export const Route = createFileRoute("/forgot-password")({
  head: () => ({ meta: [{ title: "Forgot Password — CryptoBull Pro" }] }),
  component: Forgot,
});

function Forgot() {
  const [sent, setSent] = useState(false);
  return (
    <div className="min-h-screen">
      <DisclaimerBar />
      <div className="px-4 py-10 flex flex-col items-center">
        <Brand size="lg" />
        <div className="mt-8 w-full max-w-md glass rounded-3xl p-7">
          <h1 className="text-2xl font-semibold">Reset your password</h1>
          {sent ? (
            <p className="mt-4 text-muted-foreground">Check your email for the reset link.</p>
          ) : (
            <form className="mt-5 space-y-4" onSubmit={async (e) => {
              e.preventDefault();
              const email = String(new FormData(e.currentTarget).get("email"));
              const { error } = await supabase.auth.resetPasswordForEmail(email, {
                redirectTo: window.location.origin + "/reset-password",
              });
              if (error) toast.error(error.message); else setSent(true);
            }}>
              <div className="space-y-2"><Label>Email</Label><Input name="email" type="email" required /></div>
              <Button type="submit" className="w-full">Send reset link</Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}